// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { HelloMessage } from '../Messages/HelloMessage';
import { MessageProcessorBase } from './MessageProcessorBase';
export class HelloMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        return [new HelloMessage(fieldSet)];
    }
}
